import { PracticeRegion } from './practice-region';
import { IFilterComplete } from '../filter-complete/filter-complete';

export class PracticeRegionReservation {
  public PracticeRegion: PracticeRegion;
  public PrincipalPracticeRegionId?: number;
  public Quantity: number;
  public IsAditional: boolean;
  public ProlongedDuration: boolean;
  public Id: number;
  public Name: string;
  public PracticeId: number;
  public Select: boolean;
  public AgreementPriceId?: number;
  public AditionalId?: number;
  public ServiceColor: string;
  public ServiceId: number;
  public Obligatory: boolean;
  public DiagnosticRequired: boolean;
}

export class PracticeRegionSearchReservation implements IFilterComplete {
  public Name: string;
  public Id: number;
  public Code: string;
  public SeachText: string;
  public PracticeRegionName: string;
  public ServiceId: number;
  public PracticeRegionId: number;
  public Quantity: number;
}
